import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { OrganisationBrandingProvider } from "@/app/organisation-branding-provider"
import { OrganisationProvider } from "@/app/organisation-provider"
import { useRealtime } from "@/hooks/use-realtime"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation"
)({
  beforeLoad: ({ context, params }) => {
    const { brand, session } = context
    const organisation = session.organisations.find(
      (membership) => membership.id === brand.id
    )

    if (organisation) {
      return { organisation }
    }

    if (session.portal.some((entry) => entry.organisationId === brand.id)) {
      throw redirect({
        to: "/$organisation/portal",
        params: { organisation: params.organisation },
      })
    }

    throw redirect({ to: "/organisations/select" })
  },
  component: OrganisationLayout,
})

function OrganisationLayout() {
  const { organisation } = Route.useRouteContext()
  useRealtime(organisation.id)

  return (
    <OrganisationProvider organisation={organisation}>
      <OrganisationBrandingProvider>
        <Outlet />
      </OrganisationBrandingProvider>
    </OrganisationProvider>
  )
}
